import axios from "axios";
import { supabase } from "./supabaseClient"; // Importar o cliente Supabase

// Obter API URL do sistema de configuração dinâmica
const getApiUrl = () => {
  return (
    window.ENV?.REACT_APP_API_URL ||
    process.env.REACT_APP_API_URL ||
    "/api"
  );
};

const API_URL = getApiUrl();

const axiosInstance = axios.create({
  baseURL: API_URL,
});

export const historyService = {
  async getHistory(limit = 10, offset = 0) {
    try {
      const {
        data: { session },
      } = await supabase.auth.getSession();
      const token = session?.access_token;

      if (!token) {
        throw new Error(
          "Usuário não autenticado. Faça login para buscar o histórico."
        );
      }

      const response = await axiosInstance.get(`/history`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: { limit, offset },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        throw new Error(
          error.response.data.message || "Erro ao buscar histórico"
        );
      }
      throw error;
    }
  },
};
